/** Renders one tax row per authority type returned by One Source. */

import React from 'react';

import { formatPrice } from '../../../shared/utils/format';
import type { AggregatedTaxLine } from '../types/tax.types';

interface TaxLineItemProps {
  /** Per-authority tax rows from normalizeTaxResult().aggregatedTaxLines */
  taxLines: AggregatedTaxLine[];
  currencyCode: string;
  locale: string;
}

/** Body/Sm/Regular — #002B66 @ 70% opacity, Noto Sans 14px/24px regular */
const rowClass = 'flex justify-between items-center font-noto text-[14px] font-normal leading-[24px] text-[#002B66]/70';

const TaxLineItem: React.FC<TaxLineItemProps> = ({ taxLines, currencyCode, locale }) => {
  if (!taxLines || taxLines.length === 0) {
    return null;
  }

  return (
    <>
      {taxLines.map((line) => {
        const ratePercent = (line.taxRate * 100).toFixed(2).replace(/\.?0+$/, '');
        const label = `Total ${line.authorityType} (${ratePercent}%):`;
        const formattedAmount = formatPrice(
          { centAmount: Math.round(line.taxAmount * 100), currencyCode },
          locale
        );

        return (
          <div key={line.authorityType} className={rowClass}>
            <span>{label}</span>
            <span>{formattedAmount}</span>
          </div>
        );
      })}
    </>
  );
};

export default TaxLineItem;
